function Unpaid() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="indeterminate-circle-fill">
        <path
          id="Vector"
          d="M8.00016 14.6666C4.31826 14.6666 1.3335 11.6818 1.3335 7.99998C1.3335 4.31808 4.31826 1.33331 8.00016 1.33331C11.682 1.33331 14.6668 4.31808 14.6668 7.99998C14.6668 11.6818 11.682 14.6666 8.00016 14.6666ZM4.66683 7.33331V8.66665H11.3335V7.33331H4.66683Z"
          fill="#B83131"
        />
      </g>
    </svg>
  );
}

export default Unpaid;
